<template>
    <div>
        <config-main-title>
            Tipos de Arquivo
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-6">
                <az-input icon="fas fa-search" v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluirTipoArquivo()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-3">
                <az-input  
                    icon="fa fa-filter"
                    type="select"
                    placeholder="Todos..."
                    :optionsList="lista_models"
                    optionsData="id"
                    v-model="filtro_model_type" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div
                    class="btn-group mb-1"
                    role="group"
                    aria-label="Basic example"
                >
                    <button
                        type="button"
                        class="btn"
                        :class="
                            viewMode == 'A'
                                ? 'btn-secondary'
                                : 'btn-outline-secondary'
                        "
                        @click="viewMode = 'A'"
                    >
                        Ativos
                    </button>
                    <button
                        type="button"
                        class="btn"
                        :class="
                            viewMode == 'T'
                                ? 'btn-secondary'
                                : 'btn-outline-secondary'
                        "
                        @click="viewMode = 'T'"
                    >
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column" v-if="false">
                <button
                    type="button"
                    class="btn btn-outline-success"
                    @click="incluirTipoArquivo()"
                >
                    Incluir
                </button>
            </div>
        </div>

        <div v-if="dados && lista.length">
            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li
                    class="list-group-item"
                    v-for="(dado, id) in lista"
                    :key="id"
                >
                    <div class="d-flex justify-content-between">
                        <div>
                            <span class="h5 card-link mb-0 mr-3">
                                <a href="#" @click.prevent="editar(dado)">
                                    {{ dado.search }}
                                </a>

                                <span v-if="dado.fl_enviar_pacs" class="ml-2">
                                    <i class="fa-solid fa-x-ray"></i>
                                </span>

                                <span v-if="dado.fl_tem_validade" class="ml-2">
                                    <i class="fa-regular fa-calendar-check"></i>
                                </span>
                            </span>
                            <div v-if="dado.js_classes && dado.js_classes.length">
                                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                    <span class="badge badge-success mr-1">
                                        {{ classe }}
                                    </span>
                                </a>
                            </div>
                        </div>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    :id="'categoria-' + id"
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)"
                                />
                                <label class="custom-control-label" :for="'categoria-' + id"></label>
                            </div>

                            <div v-else>
                                <span class="badge badge-secondary" v-if="dado.st_sigla">
                                    {{ dado.st_sigla }}
                                </span>
                            </div>
                        </span>
                    </div>
                </li>
            </div>

            <pre v-if="1 == 0">{{ dados }}</pre>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum tipo de arquivo registrado." />
        </div>

        <!-- Modal -->
        <div
            class="modal fade"
            id="tipoArquivoModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Tipo de arquivo
                            <span class="badge badge-secondary ml-1" v-if="item.id_tipo_arquivo">#{{ item.id_tipo_arquivo }}</span>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Descrição"
                                    required
                                    :validate="validate"
                                    v-model="item.st_descricao"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Sigla"
                                    :validate="validate"
                                    v-model="item.st_sigla"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Origem"
                                    type="select"
                                    placeholder="Qualquer..."
                                    :optionsList="lista_models"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_model_type" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Id externo"
                                    :validate="validate"
                                    v-model="item.st_id_externo"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Enviar esse tipo de anexo para o PACS"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_enviar_pacs"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Controle de Validade"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_tem_validade"
                                />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Pedido Médico"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_pedido"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Enviar esse tipo de anexo na solicitação de autorização"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_enviar_solic"
                                />
                            </div>

                            <div class="col col-12 col-md-3" v-if="item.fl_tem_validade">
                                <az-input
                                    :compact="true"
                                    label="Validade"
                                    type="number"
                                    placeholder="Não Definida..."
                                    :validate="validate"
                                    v-model="item.in_validade_padrao_dias">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.in_validade_padrao_dias">
                                            <span class="input-group-text">dias</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                         <div class="row mt-3" v-if="enviar_siad">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Enviar esse tipo de anexo na integração com o SIAD"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_enviar_siad"
                                />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_tipo_arquivo" model="tipoArquivo" :id="item.id_tipo_arquivo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_tipo_arquivo ? "Atualizar" : "Incluir" }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import Multiselect from 'vue-multiselect';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            filtro_model_type: "", 
            enviar_siad: false,
            options_classes: [], 
        };
    },

    computed: {
        lista: function() {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(" ", ".*");
            let match = parts;
            let reg = new RegExp(match, "i");

            return this.dados.filter(item => !this.filtro_model_type || this.filtro_model_type == item.st_model_type)
                .filter(item => {
                    return (
                        (item.fl_ativo || this.viewMode == "T") &&
                        (!this.search || reg.test(JSON.stringify(item)))
                    );
                });
        },

        lista_models: function() { 
            return [
                {  id: 'App\\azure\\apoiado', search: 'Apoiado' },
                {  id: 'App\\azure\\marcacao', search: 'Atendimento/Marcação' },
                {  id: 'App\\azure\\fornecedor', search: 'Fornecedor' }, 
                {  id: 'App\\azure\\lancamento', search: 'Lançamento (Financeiro)' }, 
                {  id: 'App\\azure\\laudo', search: 'Laudo' }, 
                {  id: 'App\\azure\\operadora', search: 'Operadora' }, 
                {  id: 'App\\azure\\orcamento', search: 'Orçamento' }, 
                {  id: 'App\\azure\\pessoa', search: 'Paciente' }, 
                {  id: 'App\\azure\\medicoUnidade', search: 'Prestador de Serviço' }, 
                {  id: 'App\\azure\\medicoSolicitante', search: 'Profissional Solicitante' }, 
                {  id: 'App\\azure\\solicitacaoAutorizacao', search: 'Solicitação de Autorização' }, 
                {  id: 'App\\azure\\estoqueItem', search: 'Suprimentos - Item' }, 
                {  id: 'App\\azure\\estoqueNotaFiscal', search: 'Suprimentos - Nota Fiscal' }, 
                {  id: 'App\\azure\\tarefa', search: 'Tarefa' }, 
            ];
        }
    },

    components: {
        ConfigMainTitle,
        AzEmptyState,
        AzInput,
        AzSubmit,
        Multiselect, 
        AzAuditLogButton, 
    },

    methods: {
        filtrar(texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },
        
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        atualizar() {
            this.$util.atualizar(this, {
                service: "tipos_arquivo",
                dados: this.item,
                modal: "tipoArquivoModal",
                reload: true
            });
        },

        editar(item) {
            this.item = null;

            this.$nextTick(() => {
                this.item = _.cloneDeep(item);

                $("#tipoArquivoModal").modal("show");
            });
        },

        toggle(item) {
            this.$util.toggle(this, {
                service: "tipos_arquivo",
                dados: item
            });
        },

        incluirTipoArquivo() {
            this.item = null;
            (this.validate = false),
                this.$nextTick(() => {
                    this.item = {
                        st_descricao: "",
                        st_sigla: "",
                        st_id_externo: ""
                    };
                    $("#tipoArquivoModal").modal("show");
                });
        },

        load() {
            this.$util.load(this, {
                service: "tipos_arquivo",
                configs: ['integracao-siad'],
                parms: {
                    cadastro: true
                },
                final: () => {
                    this.enviar_siad = !!this.$store.state.contexto['integracao-siad'];
                    console.log('SIAD?', this.enviar_siad);
                }
            });
        }
    },

    mounted() {
        this.load();

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Tipos de Arquivo", path: "" }
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);

        this.$util.loadItem(this, { 
            service: 'tipos_arquivo',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    }
};
</script>
